import {
  PARAM_IS_EMBEDDED_VIEW,
  PARAM_ENABLE_SAFE_HEADER
} from '../constants/params'
import { SessionStorageManager } from '../helper/localStorage'
import { smartParseParam, getUrlParamValue } from '../helper/params'
import React from 'react'

export const AppParamsContext = React.createContext(null)

const parseBooleanParam = (v) => {
  return v === true || v === 1 || v === '1' || v === 'true'
}

const resolveParamsMiniApp = (config) => {
  const param = getUrlParamValue(config.paramKey)

  if (param !== null && param !== undefined) {
    SessionStorageManager.setItem(config.storageKey, param)
  }

  const raw =
    param ??
    SessionStorageManager.getItem(config.storageKey) ??
    smartParseParam(process.env?.[config.envKey]) ??
    config.defaultValue

  return config.parser ? config.parser(raw) : raw
}

const PARAMS_MINIAPP_SCHEMA = {

  isEmbeddedView: {
    paramKey: PARAM_IS_EMBEDDED_VIEW,
    storageKey: PARAM_IS_EMBEDDED_VIEW,
    envKey: 'REACT_APP_PARAM_IS_EMBEDDED_VIEW',
    defaultValue: false,
    parser: parseBooleanParam
  },
  enableSafeHeader: {
    paramKey: PARAM_ENABLE_SAFE_HEADER,
    storageKey: PARAM_ENABLE_SAFE_HEADER,
    envKey: 'REACT_APP_TAX_ENABLE_SAFE_HEADER',
    defaultValue: false,
    parser: parseBooleanParam
  }
}

export const AppParamsContextProvider = (props) => {
  const paramsMiniApp = React.useMemo(() => {
    const params = {}

    Object.keys(PARAMS_MINIAPP_SCHEMA).forEach((key) => {
      params[key] = resolveParamsMiniApp(PARAMS_MINIAPP_SCHEMA[key])
    })

    return params
  }, [])

  return React.createElement(
    AppParamsContext.Provider,
    { value: paramsMiniApp },
    props.children
  )
}

export const useAppParamsContext = () => {
  const context = React.useContext(AppParamsContext)

  if (!context) {
    throw new Error(
      'useAppParamsContext must be used within AppParamsContextProvider'
    )
  }

  return context
}